export default function ManagePageListCtrl(NewsfeedCollection, ConfirmService) {
  'ngInject';

  const controller = this;
  controller.inprogress = false;

  Object.defineProperty(controller, 'pages', {
    get() {
      return NewsfeedCollection.pages;
    },
  });

  controller.deletePage = function deletePage(page) {
    ConfirmService.ask('Are you sure you want to delete this page?', () => {
      page.remove();
    }).ignoreCancel();
  };
}
